import script from "./ComicView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComicView.vue?vue&type=script&setup=true&lang=ts"

import "./ComicView.vue?vue&type=style&index=0&id=666c306e&lang=css"

const __exports__ = script;

export default __exports__